export default __webpack_public_path__ + "static/media/twitterNoFill.e3fa91e9.svg";